import React from 'react';

const   HeroSection = () => {
  return (
    <section className="hero-section1">
      <div className="container-fluid px-5">
        <div className="row">
          <div className="col box">
            <h3 className='col2'>Services</h3>
            <p className='paraC1'>Customized décor solutions for walls, windows & every corner of your home.</p>
            <a href='/services' className='heroLink'>Enquiry Now</a>
          </div>
          <div className="col box">
            <h3 className='col2'>Gifting</h3>
            <p className='paraC1'>Discover elegant décor gifts that add charm to every home.</p>
            <a href='/gifting' className='heroLink'>Enquiry Now</a>
          </div>
          <div className="col box">
            <h3 className='col2'>Bulk Deals</h3>
            <p className='paraC1'>explore our exclusive bulk deals on home décor items!</p>
            <a href='/bulk-deals' className='heroLink'>Enquiry Now</a>
          </div>
          <div className="col box">
            <h3 className='col2'>Coorporate Relations</h3>
            <p className='paraC1'>Redefining workplace elegance with bespoke décor and corporate gifts.</p>
            <a href='/corporate' className='heroLink'>Enquiry Now</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
